const headerKey = (section) => String(section?.headerKey || '');
const sectionKey = (section) => section?.id ? `section:${section.id}` : `draft:${section?.draftId || ''}`;
const headingKey = (heading) => heading?.id ? `section-header:${heading.id}` : `section-header-draft:${heading?.draftId || ''}`;
const byOrder = (rows) => rows.slice().sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
const numberSections = (rows) => rows.map((section, index) => ({ ...section, sort_order: index + 1 }));

// Only drafts are normalized. Published order changes when these drafts are saved.
export function groupSectionsByHeading(sections = [], headings = []) {
  const sorted = byOrder(sections);
  if (!headings.length) return numberSections(sorted);
  const keys = byOrder(headings).map(headingKey);
  const validKeys = new Set(keys);
  const groups = new Map(keys.map((key) => [key, []]));
  const unassigned = [];
  sorted.forEach((section) => {
    if (validKeys.has(headerKey(section))) groups.get(headerKey(section)).push(section);
    else unassigned.push(section);
  });
  return numberSections([...keys.flatMap((key) => groups.get(key)), ...unassigned]);
}

export function moveSectionWithinHeading(sections, headings, key, offset) {
  const sorted = groupSectionsByHeading(sections, headings);
  const index = sorted.findIndex((section) => sectionKey(section) === key);
  const target = index + offset;
  if (index < 0 || target < 0 || target >= sorted.length
    || headerKey(sorted[index]) !== headerKey(sorted[target])) return sorted;
  const next = sorted.slice();
  const [section] = next.splice(index, 1);
  next.splice(target, 0, section);
  return numberSections(next);
}

export function dropSectionWithinHeading(sections, headings, sourceKey, targetKey, position) {
  const sorted = groupSectionsByHeading(sections, headings);
  const source = sorted.findIndex((section) => sectionKey(section) === sourceKey);
  const target = sorted.findIndex((section) => sectionKey(section) === targetKey);
  if (source < 0 || target < 0 || source === target
    || headerKey(sorted[source]) !== headerKey(sorted[target])) return sorted;
  const next = sorted.slice();
  const [section] = next.splice(source, 1);
  let insertion = target + (position === 'after' ? 1 : 0);
  if (source < target) insertion -= 1;
  next.splice(insertion, 0, section);
  return numberSections(next);
}

export function resolveUsefulDropPosition(sourceIndex, targetIndex, position) {
  if (sourceIndex < 0 || targetIndex < 0 || sourceIndex === targetIndex) return '';
  // Both halves of an adjacent row should move the dragged row, rather than
  // offering an insertion point that merely puts it back where it started.
  if (targetIndex === sourceIndex + 1) return 'after';
  if (targetIndex === sourceIndex - 1) return 'before';
  return position;
}
